import LatestBookedGamesTable from './components/LatestBookedGamesTable';

export default function LatestBookedGamesPage() {
  return <LatestBookedGamesTable />;
}
